import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

export class TypedFormControl<T> extends UntypedFormControl {
    public readonly value: T;
    public valueChanges: Observable<T>;

    public addValidators(newValidator: ValidatorFn[]): void {
        const validators = this.validator ? [...newValidator, this.validator] : newValidator
        super.setValidators(validators);
    }

    public setValue(
        value: T,
        options?: {
            onlySelf?: boolean;
            emitEvent?: boolean;
            emitModelToViewChange?: boolean;
            emitViewToModelChange?: boolean;
        }
    ): void {
        this.validateParentControlState();
        super.setValue(value, options);
    }

    public reset(
        formState?: any,
        options?: {
            onlySelf?: boolean;
            emitEvent?: boolean;
        }
    ): void {
        this.validateParentControlState();
        super.reset(formState, options);
    }

    public isRequired(): boolean {
        if (!this.validator) {
          return false;
        }
        const validator = this.validator({} as AbstractControl);
        return validator && validator.required;
      }

    private validateParentControlState(): void {
        if (this.parent && this.parent.disabled) {
            /* eslint-disable-next-line no-console */
            console.warn('Попытка обновить состояние контрола с disabled родителем');
        }
    }
}
